import { render } from "./InvoiceDisplay1.vue?vue&type=template&id=0936e65e&scoped=true"
import script from "./InvoiceDisplay1.vue?vue&type=script&lang=js"
export * from "./InvoiceDisplay1.vue?vue&type=script&lang=js"

import "./InvoiceDisplay1.vue?vue&type=style&index=0&id=0936e65e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0936e65e"]])

export default __exports__